import { h } from '@/lib/dom';

type CardChild = Node | string | number | false | null | undefined;

export interface CardProps {
  title?: string;
  badge?: Node | string;
  footer?: Node | string;
  compact?: boolean;
  children?: CardChild | CardChild[];
  ariaLabel?: string;
}

export function Card(props: CardProps): HTMLElement {
  const classes = ['card'];
  if (props.compact) classes.push('compact');
  const childNodes: CardChild[] = [];
  if (props.title) {
    childNodes.push(
      h('div', { class: 'card-title', style: 'display:flex; gap:8px; align-items:center; justify-content:space-between;' }, [
        h('span', null, props.title.toUpperCase()),
        props.badge ? (typeof props.badge === 'string' ? h('span', null, props.badge) : props.badge) : null,
      ]),
    );
  }
  if (props.children) {
    if (Array.isArray(props.children)) {
      for (const c of props.children) {
        if (c === null || c === undefined || c === false) continue;
        childNodes.push(c);
      }
    } else {
      childNodes.push(props.children);
    }
  }
  if (props.footer) {
    childNodes.push(
      h('div', { class: 'card-footer' },
        typeof props.footer === 'string' ? h('span', null, props.footer) : props.footer),
    );
  }
  return h('section', {
    class: classes.join(' '),
    aria: props.ariaLabel ? { label: props.ariaLabel } : undefined,
  }, childNodes);
}
